import { createContext, useContext, useState, useCallback } from "react";
import en from "./en.json";
import es from "./es.json";

const translations = { en, es };

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [langs, setLangs] = useState({
    web_app: "en",
    client_portal: "en",
    crew_portal: "en",
  });

  const updateLangs = useCallback((newLangs) => {
    setLangs(prev => ({ ...prev, ...newLangs }));
  }, []);

  // t(key, component) -> returns translated string
  // component: "web_app" | "client_portal" | "crew_portal"
  const t = useCallback((key, component = "web_app") => {
    const lang = langs[component] || "en";
    return translate(key, lang);
  }, [langs]);

  return (
    <I18nContext.Provider value={{ langs, updateLangs, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

// Standalone translate function for portal pages that get lang from API
export function translate(key, lang = "en") {
  const dict = translations[lang] || translations.en;
  const parts = key.split(".");
  let val = dict;
  for (const p of parts) {
    val = val?.[p];
    if (val === undefined) break;
  }
  if (val !== undefined) return val;
  // fallback to English
  let fallback = translations.en;
  for (const p of parts) {
    fallback = fallback?.[p];
    if (fallback === undefined) return key;
  }
  return fallback || key;
}
